import { COUNTRIES_BY_CODE } from "@redotech/locale/countries";
import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type CustomerCountryState = readonly string[];

export const CUSTOMER_COUNTRY = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CustomerCountryState>>,
): ConditionType<CustomerCountryState, Condition.CustomerCountry> => ({
  name: "Customer country",
  description(state) {
    return `Countries: ${state.length} selected`;
  },
  Details(props: ConditionTypeDetailsProps<CustomerCountryState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return model.countries;
  },
  toModel(state) {
    return { type: Condition.CUSTOMER_COUNTRY, countries: state };
  },
  valid(state) {
    return (
      // Make sure all countries are valid.
      state.length > 0 && state.every((country) => !!COUNTRIES_BY_CODE[country])
    );
  },
});
